import type { Order, OrderStatus } from '../types/order';

// Passaggi di stato ammessi: stessa tabella di order_status_transition_allowed
// nella migration 20261004020000_order_lifecycle.sql, che li impone nel DB.
// Qui servono solo a mostrare all'admin le scelte possibili.
const TRANSITIONS: Record<OrderStatus, OrderStatus[]> = {
  pending: ['confirmed', 'processing', 'cancelled', 'refunded'],
  confirmed: ['processing', 'shipped', 'cancelled', 'refunded'],
  processing: ['confirmed', 'shipped', 'cancelled', 'refunded'],
  shipped: ['processing', 'delivered', 'refunded'],
  delivered: ['shipped', 'completed', 'refunded'],
  completed: ['delivered', 'refunded'],
  cancelled: ['refunded'],
  refunded: [],
};

/** Stato attuale più quelli raggiungibili, nell'ordine del flusso. */
export const statusOptions = (current: OrderStatus): OrderStatus[] =>
  (Object.keys(TRANSITIONS) as OrderStatus[]).filter((s) => s === current || TRANSITIONS[current].includes(s));

/** Un ordine incassato non si cancella (lo impone anche il DB): si annulla o si rimborsa. */
export const canDeleteOrder = (o: Pick<Order, 'payment_status' | 'amount_paid' | 'refunded_amount'>) =>
  !['paid', 'refunded'].includes(o.payment_status) && o.amount_paid === null && !(o.refunded_amount > 0);
